import { jsx } from 'react/jsx-runtime';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import styles from '../../styles/uitk-egds-text.css';
import { EGDSSubHeadingTags, EGDSTypeAlignments, EGDSTypeOverflows, EGDSTypeHyphens } from '../types/index.esm.js';
import { classNames } from '../../utils/classnames/index.esm.js';
import { useEGDSContext } from '../../utils/context-provider/index.esm.js';
const getClassNameList = classNames.bind(styles);
/**
 * Use only for subheadings, which immediately follow a heading.
 * Should not be used standalone or inline with other content.
 */
const EGDSSubheading = props => {
  const {
    align,
    className,
    children,
    tag,
    overflow,
    hyphens,
    ...attributes
  } = props;
  const defaultTag = 'p';
  const Tag = tag && EGDSSubHeadingTags.get(tag) || defaultTag;
  const {
    data: contextData
  } = useEGDSContext();
  const {
    bottomScrimContext,
    overlayScrimContext,
    contextClassNames
  } = contextData ?? {};
  const wrapperClassNames = getClassNameList('uitk-subheading', align && EGDSTypeAlignments.get(align), overflow && EGDSTypeOverflows.get(overflow), hyphens && EGDSTypeHyphens.get(hyphens), bottomScrimContext && `in-bottom-scrim`, overlayScrimContext && `in-overlay-scrim`, contextClassNames?.EGDSSubheading, className);
  return children ? jsx(Tag, {
    className: wrapperClassNames,
    ...attributes,
    children: children
  }) : null;
};
export { EGDSSubheading };